import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'evergreen-ui';

import * as userResource from 'resources/user/hooks';

import * as userApi from 'resources/user/user.api';

import uiNotificationService from 'services/uiNotification.service';

import Button from 'components/UI/Button';

import styles from './styles.module.scss';

const showVerificationToaster = false;

const PrivateScope = ({ children, isEmailVerificationToast }) => {
  const { data: user } = userResource.useCurrentUser();

  const onSendVerificationEmail = useCallback(async () => {
    try {
      await userApi.sendVerificationEmail();
      uiNotificationService.showSuccess('Verification email sent!');
    } catch (error) {
      uiNotificationService.showError(error.data);
    }
  }, []);

  const verificationToast = (
    <Alert
      intent="warning"
      className={styles.alertContainer}
      title="Check email to confirm your account."
    >
      <div className={styles.alertBody}>
        <p>Don’t see it?</p>

        <Button className={styles.resendBtn} type="link" onClick={onSendVerificationEmail}>
          Resend verification email.
        </Button>
      </div>
    </Alert>
  );

  const showToaster = isEmailVerificationToast && user && !user.app_state.is_email_verified;

  return (
    <div className={styles.wrapper}>
      {showVerificationToaster && showToaster && verificationToast}

      <main className={styles.scopeContent}>{children}</main>
    </div>
  );
};

PrivateScope.propTypes = {
  children: PropTypes.node.isRequired,
  isEmailVerificationToast: PropTypes.bool,
};

PrivateScope.defaultProps = {
  isEmailVerificationToast: true,
};

export default PrivateScope;
